module.exports = __webpack_public_path__ + "static/media/blue-loader.7b1eb474.svg";